module.exports = __webpack_public_path__ + "static/hccoffeehearty-dba59b0736e218190a50f2738e6fd9db.jpg";